/**
 * Template: Customers
 * -----------------------------------------------------------------------------
 * Used to import styles for all customer templates.
 *
 */
 import '@/templates/page.scss'


 document.addEventListener('DOMContentLoaded', () => {
 })
